import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box, Button } from "@mui/material";
import { getJwtTokenFromIdToken } from "../auth/AuthFanc";
import PageTitle from "../../molecules/PageTitle";
import BackButton from "../../atoms/Button/BrowserBackButton";
import { CustomContainer } from "../../../styles/styles";
import AssistanceMonitor from "./AssistanceMonitor";
import CloseIcon from "@mui/icons-material/Close";

interface SDC {
  autoSdcId: number;
  sdcUuid: string;
  sdcSerialNumber: string;
  doorPlace: string;
  isEnabled: boolean;
  isSpeakerEnabled: boolean;
  building: {
    autoBuildingId: number;
    buildingId: string;
    buildingManagementId: string;
    buildingName: string;
    buildingAddress: string;
  };
}

const AssistanceMonitorPage: React.FC = () => {
  const { autoBuildingId } = useParams();
  const [sdcs, setSdcs] = useState<SDC[]>([]);
  const [buildingInfo, setBuildingInfo] = useState<SDC["building"] | null>(
    null
  );

  useEffect(() => {
    console.log("autoBuildingId:", autoBuildingId); // デバッグ用
    const fetchSDCs = async () => {
      try {
        const jwtToken = await getJwtTokenFromIdToken();
        const response = await fetch(
          `${process.env.REACT_APP_API_ENDPOINT}/buildings/${autoBuildingId}/sdcs/`,
          {
            headers: {
              Authorization: jwtToken,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        const formattedSdcs: SDC[] = data.sdcs
          .filter((sdc: any) => sdc.isSpeakerEnabled) // isSpeakerEnabled が true のみ残す
          .map((sdc: any) => ({
            ...sdc,
            sdcUuid: sdc.sdcUuid,
          }));
        setSdcs(formattedSdcs);

        if (data.sdcs.length > 0) {
          setBuildingInfo(data.sdcs[0].building);
        }
      } catch (error) {
        console.error("Error fetching SDCs:", error);
        setBuildingInfo(null);
      }
    };

    fetchSDCs();
  }, [autoBuildingId]);

  const handleClose = () => {
    // ウィンドウを閉じる
    if (window.confirm("本当に閉じますか？")) {
      window.close();
    }
  };

  return (
    <CustomContainer maxWidth={false}>
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        marginBottom={2}
      >
        <PageTitle title="介助要請モニタ" />
        <Button
          variant="outlined"
          color="primary"
          onClick={handleClose}
          startIcon={<CloseIcon />}
        >
          閉じる
        </Button>
      </Box>

      {buildingInfo && (
        <>
          <Box marginBottom={4}>
            <h2
              style={{
                fontSize: "1.25rem",
                fontWeight: 500,
                marginBottom: "0.5rem",
              }}
            >
              建物名称：{buildingInfo.buildingName}
            </h2>
          </Box>

          <AssistanceMonitor sdcs={sdcs} buildingId={buildingInfo.buildingId} />
        </>
      )}
    </CustomContainer>
  );
};

export default AssistanceMonitorPage;
